"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerLimitSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@/app/shared/components");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const scheduler_1 = require("@/app/SUMOCEP/store/scheduler");
const skeleton_1 = require("primereact/skeleton");
const react_redux_1 = require("react-redux");
const SchedulerLimitSection = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const limit = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectLimit);
    const isLoaded = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectIsSchedulerLoaded);
    const handleLimitChange = (value) => {
        dispatch(scheduler_1.SUMOCEPSchedulerActions.setLimit(value));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-6px', children: [(0, jsx_runtime_1.jsxs)("div", { className: 'flex-left-center gap-4px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-xs-reg text-gray-80', children: labels_1.default.SCHEDULER_LIMIT_LABEL }), (0, jsx_runtime_1.jsx)("div", { className: 'flex -my-4px', children: (0, jsx_runtime_1.jsx)(components_1.Tooltip, { text: labels_1.default.SCHEDULER_LIMIT_TOOLTIP }) })] }), !isLoaded ? ((0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { className: 'w-120px h-32px border-radius-6px' })) : ((0, jsx_runtime_1.jsx)(components_1.Dropdown, { className: 'w-fit', options: scheduler_1.LIMIT_OPTIONS, value: limit, onChange: handleLimitChange }))] }));
};
exports.SchedulerLimitSection = SchedulerLimitSection;
